/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  /* op-collection-filter-exclusions ----------------------------------------
   * Hides specific filter values on specific collection pages.
   * To exclude more values, add an entry to EXCLUSIONS below:
   *   '<collection-handle>': { '<filter-param-name>': ['Value 1', 'Value 2'] }
   * Filter param names look like 'filter.p.m.custom.<key>' for product
   * metafields, or 'filter.v.option.<name>' for variant options.
   * Hide is visual only; direct URL-with-filter still works.
   * ------------------------------------------------------------------------ */
  var EXCLUSIONS = {
    'unisex': {
      'filter.p.m.custom.category': ['Unisex', "Women's"]
    },
    'women': {
      'filter.p.m.custom.category': ['Unisex', "Women's"]
    },
    'kids': {
      'filter.p.m.custom.category': ["Women's", 'Kids']
    },
    'fitted': {
      'filter.p.m.custom.category': ["Women's"]
    },
    'towel': {
      'filter.p.m.custom.category': ['Towel']
    },
    'denim-1': {
      'filter.p.m.custom.category': ['Denim']
    },
    'denim': {
      'filter.p.m.custom.category': ['Denim']
    }
  };

  function getCollectionHandle() {
    var m = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    // Fallback for very old browsers: escape characters that have meaning in selectors
    return String(value).replace(/([\\"'\[\]:.#()\s])/g, '\\$1');
  }

  function applyExclusions() {
    var handle = getCollectionHandle();
    if (!handle || !EXCLUSIONS[handle]) return;
    var rules = EXCLUSIONS[handle];
    Object.keys(rules).forEach(function(paramName) {
      rules[paramName].forEach(function(value) {
        var selector = 'input[name="' + cssEscape(paramName) + '"][value="' + cssEscape(value) + '"]';
        document.querySelectorAll(selector).forEach(function(input) {
          var li = input.closest('li');
          if (li && li.style.display !== 'none') li.style.display = 'none';
        });
      });
    });
  }

  function initFilterExclusions() {
    applyExclusions();
    var target = document.getElementById('MainContent') || document.body;
    if (!target || !window.MutationObserver) return;
    var debounceTimer = null;
    var observer = new MutationObserver(function() {
      if (debounceTimer) return;
      debounceTimer = setTimeout(function() {
        debounceTimer = null;
        applyExclusions();
      }, 50);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterExclusions);
  } else {
    initFilterExclusions();
  }


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


/* op-coming-soon ------------------------------------------------------------
   Relabels sold-out UI as "Coming Soon" for products tagged 'coming-soon'
   (handle list emitted by snippets/custom-coming-soon.liquid via the
   'coming-soon' smart collection). Only rewrites labels Broadcast already
   renders for unavailable products, so it self-expires when stock arrives.
   Covers: PDP buy button + sticky cart bar, grid/search card badge + price
   label, quick-view modal; re-applies after variant changes and AJAX
   re-renders (MutationObserver). Fully isolated: no Broadcast JS calls. */
(function () {
  var LABEL = 'Coming Soon';

  function handles() { return window.opComingSoonHandles || []; }

  function handleFromUrl(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function cardHandle(card) {
    var h = handleFromUrl(card.getAttribute('data-url'));
    if (h) return h;
    var link = card.querySelector('a[href*="/products/"]');
    return link ? handleFromUrl(link.getAttribute('href')) : null;
  }

  function setFirstText(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        if (n.nodeValue.trim() !== LABEL) n.nodeValue = LABEL;
        return;
      }
    }
    if (el.textContent.trim() !== LABEL) el.textContent = LABEL;
  }

  function apply() {
    var list = handles();
    if (!list.length) return;

    // Product cards (collection grid, search, related, predictive search):
    // "Sold Out" badge and the sold-out price replacement.
    document.querySelectorAll('.badge-box.sold-box, span.sold-out').forEach(function (el) {
      var card = el.closest('[data-grid-item], .product-item');
      if (!card) return;
      var h = cardHandle(card);
      if (h && list.indexOf(h) !== -1) setFirstText(el);
    });

    // PDP + sticky cart bar: disabled add-to-cart button only, so normal
    // behavior returns untouched the moment a variant is purchasable.
    document.querySelectorAll('product-info[data-product-handle]').forEach(function (pi) {
      if (list.indexOf(pi.getAttribute('data-product-handle')) === -1) return;
      pi.querySelectorAll('button[name="add"][disabled] [data-add-to-cart-text]').forEach(setFirstText);
      // Sticky cart bar for the same product: when nothing is buyable its
      // label span drops data-add-to-cart-text, so key off the sold-out
      // wrapper state classes + .btn__text instead. Both disappear once a
      // variant is purchasable, so this self-expires too.
      document.querySelectorAll('cart-bar .variant--soldout .btn__text, cart-bar .all-variants--soldout .btn__text').forEach(setFirstText);
    });

    // Quick-view modal (fetched async; derive handle from links inside it).
    document.querySelectorAll('[data-product-upsell-ajax]').forEach(function (modal) {
      var link = modal.querySelector('a[href*="/products/"]');
      var h = link && handleFromUrl(link.getAttribute('href'));
      if (!h || list.indexOf(h) === -1) return;
      modal.querySelectorAll('button[name="add"][disabled] [data-add-to-cart-text]').forEach(setFirstText);
    });
  }

  function init() {
    if (!handles().length) return;
    apply();
    if (!window.MutationObserver) return;
    var debounceTimer = null;
    new MutationObserver(function () {
      if (debounceTimer) return;
      debounceTimer = setTimeout(function () {
        debounceTimer = null;
        apply();
      }, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
